import { cva } from 'class-variance-authority'

export const toastViewportVariants = cva(
  'z-10100 fixed space-y-5 sm:left-1/2 sm:w-full sm:max-w-md',
  {
    variants: {
      position: {
        'top-center':
          'top-20 lg:top-48 xl:top-36 left-2.5 right-2.5 sm:-translate-x-1/2 sm:transform',
        'bottom-center':
          'bottom-2.5 lg:bottom-10 left-2.5 right-2.5 sm:-translate-x-1/2 sm:transform',
      },
    },
    defaultVariants: {
      position: 'top-center',
    },
  }
)
